  <template>
  <div>
   <b-modal style="padding:15px" size="lg" id="EditWheatReceiveModal" ref="modal" title="Edit Wheat Receive" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @show= "updateModal()" @ok= "handleOk" :ok-disabled = "this.$refs.EditWheatReceiveForm != undefined ? !this.$refs.EditWheatReceiveForm.checkValidity() : true">
        <form ref="EditWheatReceiveForm" @submit.stop.prevent= "handleSubmit">
           <div class="row">
            <div class = "col-md-12">
              <b-form-group  label="" label-for="checkbox" autocomplete="off">
               <b-form-checkbox
                id="checkbox"
                v-model="IsNonInventory"
                name="checkbox-1"
                value: = true
                unchecked-value: = false
              >
               Non Inventory Transaction
              </b-form-checkbox>
              </b-form-group>
            </div>
            <div class="col-md-6">
               <b-form-group  label="Date Received" label-for="datepicker-2" autocomplete="off">
                  <b-form-datepicker id="datepicker-1" v-model= "DateReceived" placeholder="Choose a date" local="en"></b-form-datepicker>
               </b-form-group>
            </div>  
            <div class="col-md-6">
               <b-form-group  label="Vendor Issued Date" label-for="datepicker-2" autocomplete="off">
                  <b-form-datepicker id="datepicker-2" v-model= "DateIssued" placeholder="Choose a date" local="en"></b-form-datepicker>
               </b-form-group>
            </div>  
            <div class = "col-md-6">
              <b-form-group  label="Truck No" label-for="truckno" autocomplete="off">
                <b-form-input id="truckno" v-model= "TruckNo"  required></b-form-input>
              </b-form-group>
            </div>
            <div class = "col-md-6">
              <b-form-group  label="Voucher No" label-for="voucherno" autocomplete="off">
                <b-form-input id="voucherno" v-model= "VoucherNo"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="Type" label-for="Type" autocomplete="off">
                <b-form-select v-model= "SelectedTypeId" :options="wheatTypes" value-field="id" text-field="name">
                  <b-form-select-option :value = null disabled hidden>Select Type</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="Wheat Received From">
                <b-form-radio-group
                  v-model="IsGovt"
                  :options="flourOptions"
                  name="radio-inline"
                ></b-form-radio-group>
              </b-form-group>
            </div>
             <div class = "col-md-6">
              <b-form-group  label="No Of Sacks" label-for="sacks" autocomplete="off">
                <b-form-input id="sacks" v-model= "NoOfSacks" type = "number"  required></b-form-input>
              </b-form-group>
            </div>
             <div class = "col-md-6">
              <b-form-group  label="Total Weight" label-for="totalweight" autocomplete="off">
                <b-form-input id="totalweight" v-model= "TotalWeight" type = "number"  required></b-form-input>
              </b-form-group>
            </div>
          </div>  
        </form>
      </b-modal>
      <Toaster ref = "toaster"/>
      </div>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'
export default {
    name: 'EditWheatReceive',
    data(){
        return{
          moduleName:'Edit Wheat Receive',  
          TotalWeight:null,
          Id:null,
          NoOfSacks: 1,
          IsGovt:true,
          flourOptions: [
          { text: 'Govt', value: true },
          { text: 'Private', value: false },
          ],
          VoucherNo: null,
          TruckNo : null,
          DateIssued:null,
          DateReceived:null,
          IsNonInventory:true,
          wheatTypes:[],
          SelectedTypeId:null,
          
		}
  },

 props:
 {
   wheatReceive:{
     type:Object,
     default:null
   }
 },
components:{
  Toaster
},
 mounted()
    {
      // console.log(this.$auth.user())
      let model = {
        companyId:this.$auth.user().companyId
      }
       axios.post('/wheattype/getall', model)
      .then(res=>{
        console.log(res)
        this.wheatTypes = res.data.data
      });
    },
methods:{
  
   
   editWheatRec(){ 
         let model = {"Id":this.Id,"TotalWeight":parseFloat(this.TotalWeight),"NoOfSacks":parseInt(this.NoOfSacks),"IsGovt":this.IsGovt,"VoucherNo":this.VoucherNo,
       "TruckNo":this.TruckNo,"DateIssued":this.DateIssued,"DateReceived":this.DateReceived,
       "IsNonInventory":this.IsNonInventory,"WheatTypeId":this.SelectedTypeId,
       "CompanyId":this.$auth.user().companyId,"UserId":this.$auth.user().id
      }
      console.log(model)
     axios.post('/WheatReceives/Edit',model)
      .then(res=>{
        // console.log(res)
            if(res.data.status == 1)
            {
                 this.$refs.toaster.showToast('Sucess','success','Wheat entry has been updated successfully')
                 this.$bvModal.hide('EditWheatReceiveModal')
                 this.$parent.getWheatReceives();     
              
                // this.getWheatReceives();
            }
            else
            {
                this.$refs.toaster.showToast('Error','danger',res.data.msg)
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.EditWheatReceiveForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
       
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.editWheatRec()
        
      },

   updateModal()
  {
      console.log(this.wheatReceive)
        this.TotalWeight=this.wheatReceive.totalWeight;
          this.WheatTypes=this.wheatReceive.wheatTypes;
          this.IsNonInventory=this.wheatReceive.isNonInventory;
          this.DateReceived=this.wheatReceive.dateReceived;
          this.DateIssued=this.wheatReceive.dateIssued;
          this.TruckNo=this.wheatReceive.truckNo;
          this.VoucherNo=this.wheatReceive.voucherNo;
          this.IsGovt=this.wheatReceive.isGovt;
          this.NoOfSacks=this.wheatReceive.noOfSacks;
          this.Id=this.wheatReceive.id;
         
         
          this.SelectedTypeId=this.wheatReceive.wheatTypeId
    },

  }
	

}
</script>
